<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        outlined>

        <v-row>
          
          <v-col cols="12">
            <v-col
              class="pl-4 pr-4 pt-8"
              cols="12"
            >
              <v-select
                :loading="loading"
                :items="editions"
                label="Edición"
                v-model="edition_id"
                name="editions"
                :item-text="'name'"
                :item-value="'id'"
                outlined
                @change="handleSelectChange"
              ></v-select>
            </v-col>
          </v-col>
        </v-row>
      </v-sheet>

      <v-col cols="12" v-if="!$vuetify.breakpoint.xs">
        <v-row class="mt-4">
          <v-tabs
            fixed-tabs
            v-model="tabs"
            class="tab-gallery"
            :background-color="color_tab"
            dark
            slider-size="8"
            height="70px"
          >
            <v-tab @click="tabs = 0">
              Emprendimientos
            </v-tab>

            <v-tab @click="tabs = 1">
              Emprendedores
            </v-tab>
            
            <v-tab @click="tabs = 2">
              Asistentes
            </v-tab>

            <v-tab @click="tabs = 3">
              Interacciones
            </v-tab>

          </v-tabs>
        </v-row>
      </v-col>

      <v-col cols="12" v-if="$vuetify.breakpoint.xs">
        <v-row class="mt-4">
          <v-tabs
            fixed-tabs
            v-model="tabs"
            class="tab-gallery"
            :background-color="color_tab"
            dark
            slider-size="8"
            height="70px"
          >
            <v-tab @click="tabs = 0">
              <v-icon>
                mdi-rocket-launch
              </v-icon>
            </v-tab>

            <v-tab @click="tabs = 1">
              <v-icon>
                mdi-account-star
              </v-icon>
            </v-tab>
            
            <v-tab @click="tabs = 2">
              <v-icon>
                mdi-account-group-outline
              </v-icon>
            </v-tab>

            <v-tab @click="tabs = 3">
              <v-icon>
                mdi-google-analytics
              </v-icon>
            </v-tab>

          </v-tabs>
        </v-row>
      </v-col>

      <entrepreneurshipsIndicator :edition_id="edition_id" v-if="tabs==0 && !loading && !change_edition" />

      <entrepreneurialIndicators :edition_id="edition_id" v-if="tabs==1 && !loading && !change_edition" />

      <participantsIndicator :edition_id="edition_id" v-if="tabs==2 && !loading && !change_edition" />

      <interactionsIndicator :edition_id="edition_id" v-if="tabs==3 && !loading && !change_edition" />

    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import entrepreneurshipsIndicator from '@/components/admin/indicators/entrepreneurshipsIndicator.vue'
  import entrepreneurialIndicators from '@/components/admin/indicators/entrepreneurialIndicators.vue'
  import interactionsIndicator from '@/components/admin/indicators/interactionsIndicator.vue'
  import participantsIndicator from '@/components/admin/indicators/participantsIndicator.vue'

  export default {
    name: 'Indicators',
    components: {
      entrepreneurshipsIndicator,
      entrepreneurialIndicators,
      interactionsIndicator,
      participantsIndicator
    },
    data: () => ({
      loading:true,
      change_edition:false,

      editions: [],
      edition_id: null,

      tabs:0,

      entrepreneurial_count:0,
      entrepreneurial_ip_count:0,
      entrepreneurial_ip_school_count:0,
      entrepreneurial_mdn_count:0,

      entrepreneurial_register_count:0,
      entrepreneurial_no_register_count:0
    }),
    computed: {
      color_tab () {
        switch (this.tabs) {
          case 0: return '#00A1B8'
          case 1: return '#0A889E'
          case 2: return '#17677C'
          case 3: return '#23495C'
          default: return '#00A1B8'
        }
      }
    },
    watch: {
      edition_id: {
        handler: function() {
            this.change_edition=true
            setTimeout(() => {
              this.change_edition=false
            }, 50);
        },
        deep: true
      }
    },
    methods:{
      async getEditions()
      {
        await axios.get('admin/editions').then(response =>{
          this.editions = response.data
          
          if(this.editions && !this.edition_id){
            this.edition_id = this.editions[0].id
          }
        }).catch(error => {
          console.log(error);
        })
      },


      //----------------------------------------------------------------------------------//
      //----------------------------------------------------------------------------------//
      //----------------------------------------------------------------------------------//

      createdView()
      {
        this.edition_id = this.$store.state.currentEdition
      },

      handleSelectChange(edition_id)
      {
        this.$store.state.currentEdition = edition_id
      }
    },

    created(){
      
      Promise.all([
        this.createdView(),
        this.getEditions()
      ]).then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style scoped>
.tab-gallery {
  border-radius: 6px!important;
  background-color: linear-gradient(to right,#00a1b8 0%,#23495c 100%) !important;
}
</style>